import IERC20 from './contarcts/IERC20.json';
import PrivySale from './contarcts/PrivySale.json';
import TGE from './contarcts/TGE.json';

export const ENV = process.env.ENV;
export const TGE_ADDRESS = process.env.TGE_ADDRESS;
export const TMX_TOKEN_ADDRESS = process.env.TMX_TOKEN_ADDRESS;
export const TEST_NET_DOMAIN = process.env.TEST_NET_DOMAIN;
export const APP_LINK = process.env.APP_LINK;
export const APP_PRIVATE_SEED_LINK = process.env.APP_PRIVATE_SEED_LINK;
export const APP_TGE_LINK = process.env.APP_TGE_LINK;
export const REOWN_PROJECT_ID = process.env.REOWN_PROJECT_ID;

export const TRUST_WALLET_ID = '4622a2b2d6af1c9844944291e5e7351a6aa24cd7b23099efac1b2fd875da31a0';
export const META_MASK_WALLET_ID =
  'c57ca95b47569778a828d19178114f4db188b89b763c899ba0be274e97267d96';
export const EXCLUDED_WALLETS = {
  phantom: 'a797aa35c0fadbfc1a53e7f675162ed5226968b44a19ee3d24385c64d1d3c393',
};

export const TELEGRAM_LINK = 'https://t.me/+XcQOVrCMeEBlZWI8';

export const abiStorage = {
  PrivySale,
  TGE,
  IERC20,
};
